module.exports = __webpack_public_path__ + "static/media/enter_block_arrow.c981c057.svg";